import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BookMarkFolderSystemService {
  bookMarkViews: any[] = [];
  setSate: any[] = [];
  setbookMarkSateName: any
  setbookMarkSateInedx: any
  defaultView: any
  constructor(private http: HttpClient) { }

  createBookmarkFolder(body: any) {
    return this.http.post('/folder/viewset/', body);
  }
  moveBookmarkToFolder(body: any) {
    return this.http.post('/bookmark/manage-folder/', body);
  }
  removeFromFolder(body: any) {
    return this.http.post('/bookmark/manage-folder/', body);
  }
}
